import './route-row.css';
import {RouteStations} from "./route-stations";
export const RouteRow = {
    props: {
        route_num: {
            type: Number,
            required: true,
        },
        route_name: {
            type: Number,
            required: true,
        },
        route_carrier: {
            type: String,
            required: true,
        },
        route_bus: {
            type: Object,
            required: true,
        },
        route_departure_name: {
            type: String,
            required: true,
        },
        route_departure_time: {
            type: String,
            required: true,
        },
        route_arrival_name: {
            type: String,
            required: true
        },
        route_arrival_time: {
            type: String,
            required: true
        },
        route_distance: {
            type: String,
            required: true
        },
        route_duration: {
            type: String,
            required: true
        },
        passenger_cost: {
            type: String,
            required: true
        },
        total_seats: {
            type: String,
            required: true
        },
        free_seats: {
            type: String,
            required: true
        },
        trip_id: {
            type: String,
            required: true,
        },
        departure_id: {
            type: String,
            required: true,
        },
        destination_id: {
            type: String,
            required: true,
        },
        current_day: {
            type: String,
            required: true,
        },
        status: {
            type: String,
            required: true,
        },
        status_print: {
            type: String,
            required: true,
        },
        status_reason: {
            type: String,
            required: true,
        },
    },
    components:{
        RouteStations
    },
    created() {
    },
    mounted() {
    },
    data(): object {
        return {
            show_segments: false,
        }
    },
    computed: {
    },
    methods: {
        handlerErrors(errors)
        {
            if (
                typeof errors.error_message !== 'undefined'
            ) {
                this.errors = errors.error_message;
            } else if (typeof errors.error_text !== 'undefined') {
                this.errors = errors.error_text;
            }
        },

        getMinutes(number)
        {
            return ('0' + number).slice(-2);
        },

        convertDateTime(date_text) {
            let res_date = '';
            let date = new Date(date_text);
            res_date = date.getHours() + ':' + this.getMinutes(date.getMinutes())
            return res_date;
        },
        convertMinuteDuration2Hours(minutes)
        {
            let res_date = new Date(minutes * 60 * 1000).toISOString().substring(11, 19).split(':');
            return res_date[0] + 'ч' + ' ' + res_date[1] + 'мин';//new Date(minutes * 60 * 1000).toISOString().substring(11, 19)
        },
        openSegments()
        {
        },
        changeShowSegmtnts()
        {
            this.show_segments = !this.show_segments;
        },
        buyTicket(event, trip_id,current_day)
        {
            window.location.href = '/buy?route=' + trip_id + '&day=' + current_day;
        }
    },
    template: `<div className="routs-table__route-row" v-if="free_seats > 0">
                <div className="routs-table__route-field routs-table__route-num route-num">
                    <div className="routs-table__route-num-name">{{route_num}}</div>
                    <div className="routs-table__route-num-details route-num-details" @click.stop="changeShowSegmtnts()">
                        <span className="route-num-details__text">Детали</span>
                        <i className="route-num-details__ico"></i>
                    </div>
                </div>
                <div className="routs-table__route-field routs-table__route-name route-name">
                    <div className="route-name__title">{{route_name}}:</div>
                    <div className="route-name__description">
                        <span className="route-name__description-vehicle-model">{{route_bus.Model}}</span>
                        <span className="route-name__description-vehicle-capacity">{{route_bus.SeatCapacity}}</span>
                        <span className="route-name__description-vehicle-number">{{route_bus.LicencePlate}}</span>
                        <span className="route-name__description-vehicle-carriers-name">{{route_carrier}}</span>
                    </div>
                </div>
                <div className="routs-table__route-field route-departure">
                    <div className="route-departure__time">
                        <span>{{convertDateTime(route_departure_time)}}</span>
                    </div>
                    <div className="route-departure__place">
                        <span>{{route_departure_name}}</span>
                    </div>
                </div>
                <div className="routs-table__route-field route-arrival">
                    <div className="route-arrival__time">
                        <span>{{convertDateTime(route_arrival_time)}}</span>
                    </div>
                    <div className="route-arrival__place">
                        <span>{{route_arrival_name}}</span>
                    </div>
                </div>
                <div className="routs-table__route-field route-spent">
                    <div className="route-spent__time">
                        <span>{{convertMinuteDuration2Hours(route_duration)}}</span>
                    </div>
                    <div className="route-spent__distance">
                        <span>{{route_distance}} км</span>
                    </div>
                </div>
                <div className="routs-table__route-field route-link">
                    <div className="route-link__wrapper">
                        <div className="route-link__info">
                            <div className="route-link__price">
                                <span>{{passenger_cost}}</span>
                                <span className="rub"> руб.</span>
                            </div>
                            <div className="route-link__seats">
                                <span>{{free_seats}} из {{total_seats}} мест</span>
                            </div>
                        </div>
                        <div className="route-link__button button-submit">
                            <button @click.stop.prevent="buyTicket($event,trip_id,current_day)" className="button-submit__btn">Купить</button> 
                        </div>
                    </div>
                </div>
            </div>
            <RouteStations
                :is_active="show_segments"
                :trip_id="trip_id"
                :departure_id="departure_id"
                :destination_id="destination_id"
            />
`,
}